import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

interface SoftwareDownloadButtonProps {
  binary: {
    url: string;
    version: string;
    hwversion: string;
  };
}

const SoftwareDownloadButton = ({ binary: { url, version, hwversion } }: SoftwareDownloadButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button color="primary" fullWidth href={url} target="_blank" variant="contained">
      {t('service-center.software-update.download', { version, hdversion: hwversion })}
    </Button>
  );
};

export default SoftwareDownloadButton;
